// Import jQuery and Backbone (globals also provided by vendor bundle)
import $ from 'jquery';
import Backbone from 'backbone';

(function () {
  'use strict';
  window.APP = window.APP || { Routers: {}, Collections: {}, Models: {}, Views: {} };
  APP.routerViews = {};

  APP.goto = function (name) {
    APP.router.navigate(name, { trigger: true });
    return false;
  };

  APP.stepBack = function () {
    var currrentPath = window.location.hash;
    if (currrentPath == '') {
      currrentPath = window.location.pathname;
    }
    if (currrentPath.length <= 1) {
      APP.goto('/');
    } else {
      currrentPath = currrentPath.split('/');
      currrentPath.pop();
      currrentPath = currrentPath.join('/');
      APP.goto(currrentPath);
    }
    return false;
  };

  $(document).on('click', 'a:not([data-bypass])', function (e) {
    var href = $(this).prop('href');
    if (!href || !href.length || !href.slice) {
      return true;
    }
    var root = location.protocol + '//' + location.host + '/';
    // only goto if its in the router?
    let urlPath = href.slice(root.length);

    // Allow direct navigation to homepage and app page
    if (urlPath === '' || urlPath === '/' || urlPath === 'app' || urlPath === 'app/') {
      return true; // Let browser handle the navigation normally
    }

    // Home and dashboard are rendered by the server
    if (urlPath && !urlPath.startsWith('dashboard')) {
      return true;
    }
    if (root === href.slice(0, root.length)) {
      e.preventDefault();
      APP.goto(urlPath);
    }
  });

  APP.gotoLink = function (link) {
    // if(gameon.isInIFrame()) {
    //     return true;
    // }
    var href = $(link).prop('href');
    if (!href) {
      return true;
    }
    var root = location.protocol + '//' + location.host + '/';
    if (root === href.slice(0, root.length)) {
      APP.goto(href.slice(root.length));
      return false;
    }
  };

  var currentView;

  function animateTo(view) {
    var $mainbody = $('#mainbody');
    var duration = 300;
    // if (gameon.noAnimation) {
    //     duration = 0;
    // }
    //
    // $mainbody.fadeOut(duration, function () {
    //     if (currentView) {
    //         currentView.close();
    //     }
    //
    //     currentView = view;
    //     if (view.rendersAsync) {
    //         view.renderCallback = function () {
    //             $mainbody.html(view.el);
    //             $mainbody.fadeIn(duration, function () {
    //                 if (typeof specHelpers == 'object') {
    //                     specHelpers.once();
    //                 }
    //             });
    //         };
    //         view.render();
    //     }
    //     else {
    //         $mainbody.html(view.render().el);
    //
    //         $mainbody.fadeIn(duration, function () {
    //             //scroll to top
    //             $("html, body").scrollTop(0);
    //             if (typeof specHelpers == 'object') {
    //                 specHelpers.once();
    //             }
    //         });
    //     }
    // });

    //scroll to top
    $('html, body').scrollTop(0);
  }

  APP.refresh = function () {
    // APP.footer.path = location.pathname;
    // APP.header.path = location.pathname;
    // $('#headerbody').html(APP.header.render().el);
    // $('#footerbody').html(APP.footer.render().el);
    // $.ajax({ url: 'http://platform.twitter.com/widgets.js', dataType: 'script', cache: true});
  };

  function startBackboneHistoryOnce(source) {
    if (window.__helixBackboneHistoryStarted) {
      return false;
    }

    if (Backbone.history && Backbone.history.started) {
      window.__helixBackboneHistoryStarted = true;
      return false;
    }

    window.__helixBackboneHistoryStarted = true;

    try {
      Backbone.history.start({
        pushState: true
        //            silent: true
      });
      return true;
    } catch (error) {
      var message = error && error.message ? String(error.message) : '';
      if (!/already been started/i.test(message)) {
        window.__helixBackboneHistoryStarted = false;
        throw error;
      }

      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('Skipping duplicate Backbone.history.start from ' + source);
      }
      return false;
    }
  }

  APP.currentView = location.pathname;
  function defaultHandler(pathname) {
    return function () {
      var args = arguments;
      if (APP.currentView == pathname && prerenderedPages[APP.currentView]) {
        return;
      }

      APP.currentView = pathname;
      APP.refresh();

      animateTo(new APP.Views[pathname]({ args: args }));
    };
  }

  var prerenderedPages = {
    "/": "home",
    // "/about": "about",
    // "/contact": "contact",
    // "/terms": "terms",
    // "/privacy": "privacy"
  };
  var routes = {};
  $.each(prerenderedPages, function (key, value) {
    routes[key.substring(1)] = value;
  });
  $.extend(routes, {
    //pages needing js rendering
    '': 'home'
  });

  var Router = Backbone.Router.extend({
    // Define routes
    routes: routes,
    home: defaultHandler('/'),
    dashboard: defaultHandler('/dashboard')
    // 'level': defaultHandler('/level'),
    // 'contact': defaultHandler('/contact'),
    // 'about': defaultHandler('/about'),
    // 'terms': defaultHandler('/terms'),
    // 'privacy': defaultHandler('/privacy')
  });

  $(document).ready(function () {
    if (window.__helixRouterInitialized) {
      return;
    }
    window.__helixRouterInitialized = true;

    APP.router = new Router();
    // APP.header = new APP.Views.Header({path: location.pathname});
    // APP.footer = new APP.Views.Footer({path: location.pathname});
    APP.doneLevel = defaultHandler('/done-level');
    window.__helixStartBackboneHistory = startBackboneHistoryOnce;
    startBackboneHistoryOnce('src/js/router.js');

    $(document).on('click', '.ws-help-btn', function () {
      var $modal = $('#modal');
      $modal.find('.modal-body').html($('#instructions').html());
      $modal.modal('show');
    });
  });
})();
